define(['jquery', 'erv_framework', 'forms'], function ($, ERVFramework, Forms) {
	var AjaxHelper = function () {
		var self = this;
		self.forms = new Forms();
		self.framework = new ERVFramework();
	};

	AjaxHelper.prototype.submitForm = function ($form, successCallback, failCallback, completed, manualType, manualUrl) {
		var self = this,
			url = typeof (manualUrl) !== 'undefined' ? manualUrl : $form.attr('action'),
			type = typeof (manualType) !== 'undefined' ? manualType : $form.attr('method');

		//set class to override default behavior
		if (!$form.hasClass('skiploading')) {
			self.forms.activateLoading($form, false);
		}

		$.ajax({
			type: type,
			url: url,
			data: $form.serialize(),
			success: function (data) {
				if (typeof (data.status) === 'undefined' || data.status === 'success') {
					if (typeof(successCallback) === 'function') {
						successCallback(data);
					}
				} else if (typeof(failCallback) === 'function') {
					failCallback(data);
				} else {
					self.framework.initGenericAlert(typeof (data.message) !== 'undefined' ? data.message : '');
				}
				
			},
			complete: function (data) {
				if (typeof(completed) === 'function') {
					completed(data);
				} else {
					self.forms.deactivateLoading($form);
				}
			}
		});
	}

	return AjaxHelper;
});